export const cellFn = (value) => {
  if (!value) {
    return '-';
  }
  if (value.length > 150) {
    return value.slice(0, 147).replace(/\s$/, '') + '...';
  }
  return value;
};
